<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				出差申请-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
				<!-- 查询框 -->
				<div style="margin:0 0 50px 30%">
					<el-steps :space="200" :active="1" finish-status="success">
						<el-step title="发起出差"></el-step>
						<el-step title="审核中"></el-step>
						<el-step title="审核通过"></el-step>
					</el-steps>
				</div>
				<span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
				<span style="font-size:20px;font-weight:700">基本信息</span>
				<div style="border:1px solid #DADADA;margin-top:10px"></div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<!-- <el-form-item label="姓名" prop="staff_id" style="margin-top:50px">
								<el-select v-model="ruleForm.staff_id" placeholder="请选择" style="width:80%" filterable>
									<el-option v-for="item in staffList" :key="item.id" :value="item.id"
										:label="item.staff_name"></el-option>
								</el-select>
							</el-form-item> -->
							<div @click="StaffFind">
								<el-form-item label="姓名" prop="staff_id" style="margin-top:40px;width:86%">
									<el-input v-model="ruleForm.staff_name" onfocus="this.blur();">
									</el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="出差事由" prop="evection_reason">
								<el-input v-model="ruleForm.evection_reason" placeholder="请输入出差事由" style="width:80%">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<div style="margin-top:50px" v-for="(item, index) in ruleForm.evectionTripList" :key="index">
						<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
						<span style="font-size:20px;font-weight:700">行程{{index + 1}}</span>
						<img src="../../../assets/icon/减少.png" v-show="index != 0"
							style="float: right; margin-right: 20px;" width="25px" @click="delTtinerary(index)" />
						<div style="border:1px solid #DADADA;margin-top:10px"></div>

						<el-row>
							<el-col :span="12">
								<el-form-item label="交通工具" prop="dictionaries_id" style="margin-top:50px">
									<el-select v-model="evectionTripList[index].dictionaries_id" placeholder="请选择"
										style="width:80%">
										<el-option v-for="dictionaries in dictionariesList" :key="dictionaries.id"
											:label="dictionaries.data" :value="dictionaries.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="单程往返">
									<el-select v-model="evectionTripList[index].trip_type" placeholder="请选择"
										style="width:80%">
										<el-option label="单程" value="1"></el-option>
										<el-option label="往返" value="0"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="出发城市">
									<el-select v-model="evectionTripList[index].start_city" placeholder="请选择"
										style="width:80%">
										<el-option v-for="city in $globals.cityList" :key="city.city" :label="city.city"
											:value="city.city">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="目的城市">
									<el-select v-model="evectionTripList[index].end_city" placeholder="请选择"
										style="width:80%">
										<el-option v-for="city in $globals.cityList" :key="city.city" :label="city.city"
											:value="city.city">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="开始时间">
									<el-date-picker v-model="evectionTripList[index].start_date" type="datetime"
										format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" style="width:80%"
										placeholder="请选择">
									</el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="结束时间">
									<el-date-picker v-model="evectionTripList[index].end_date" type="datetime"
										format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" style="width:80%"
										placeholder="请选择">
									</el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="时长(小时)">
									<el-input v-model="evectionTripList[index].trip_duration" style="width:80%">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<div style="margin-left:5%">
							<img src="../../../assets/icon/增加行程@2x.png" @click="AddTtinerary(index + 1)"
								v-show="index === (ruleForm.evectionTripList.length - 1)">
						</div>
					</div>

					<div style="margin-top:50px">
						<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
						<span style="font-size:20px;font-weight:700">同行人</span>
						<div style="border:1px solid #DADADA;margin-top:10px"></div>
						<el-row style="margin-top: 20px;">

							<!-- <el-col :lg="5" :xl="2" v-for="(item, index) in together_evections" :key="index">
								<div style="height: 36px; width: 60%; padding: 0 10%; background-color: #ebf4f1;">
									<span style="line-height: 36px;">{{item.staff_name}}</span>
									<img src="../../../assets/icon/关闭绿@2x.png" style="margin-left: 5px;"
										@click="DelStaff(index)" />
								</div>
							</el-col>

							<el-col :lg="5" :xl="2">
								<img src="../../../assets/icon/同行人_添加@2x.png" @click="StaffFinds">
							</el-col> -->

							<el-col :span="12">
							<div @click="StaffFinds">
								<el-form-item label="姓名" prop="staff_name" style="margin-top:80px;width:80%">
									<el-input style="" v-model="ruleForm.staff_names"></el-input>
								</el-form-item>
							</div>
						</el-col>
						</el-row>
					</div>



					<el-form-item label-width="0">
						<el-row>
							<el-col :span="12" style="text-align: center;">
								<el-button type="goon" @click="Add()"
									v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
								<el-button type="goon" @click="UpdateAuditor()"
									v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
								<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
							</el-col>
						</el-row>
					</el-form-item>
				</el-form>

			</div>

		</div>

		
		<el-dialog title="请选择姓名" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="true"
			:show-close="false" :modal-append-to-body="false" :append-to-body="true">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<el-dialog title="请选择同行人" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="true"
			:show-close="false" :modal-append-to-body="false" :append-to-body="true">
			<el-row>
				<organizeStaff ref="organizeStaff" type="checkbox" :accordion="false" @commit="saveChanges"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择同行人" :visible.sync="dialogVisible" width="25%" :before-close="handleClose">

			<el-select v-model="staff_id" placeholder="请选择" style="width:100%" filterable>
				<el-option v-for="item in staffList" :key="item.id" :value="item.id" :label="item.staff_name">
				</el-option>
			</el-select>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="AddStaff" style="background-color: #006E4B; border-color: #006E4B;">确
					定</el-button>
			</span>
		</el-dialog> -->

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="9" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog> -->

	</div>
</template>

<script>
import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			SelectAuditor: SelectAuditor,
			organizeStaff: organizeStaff,
		},
		data() {
			return {
				
				//表单数据
				ruleForm: {
					id: '',
					staff_id: '',
					staff_names:'',
					evection_reason: '',
					together_evection: '',
					evectionTripList: [{
						id: "",
						dictionaries_id: "",
						start_city: "",
						end_city: "",
						trip_type: "",
						trip_duration: "",
						start_date: "",
						end_date: "",
					}],
					evectionTrip: {
						id: "",
						dictionaries_id: "",
						start_city: "",
						end_city: "",
						trip_type: "",
						trip_duration: "",
						start_date: "",
						end_date: "",
					},
					examineDetailsList: [],
				},

				//表单验证
				rules: {
					staff_id: [{
						required: true,
						message: '请选择员工！',
						trigger: 'blur'
					}],
					evection_reason: [{
						required: true,
						message: '请输入出差事由！',
						trigger: 'blur'
					}],
				},

				//页面相关
				dialogVisible: false,
				dialogVisibles:false,
				dialogAuditorVisible: false,

				//行程暂存
				evectionTripList: [{
					id: "",
					dictionaries_id: "",
					start_city: "",
					end_city: "",
					trip_type: "",
					trip_duration: "",
					start_date: "",
					end_date: "",
					index: 0
				}],

				//同行人
				together_evections: [],
				//同行人暂存
				staff_id: "",

				//员工下拉
				staffList: [],
				//交通工具
				dictionariesList: [],

			};
		},
		methods: {
			//添加行程
			AddTtinerary(e) {
				this.ruleForm.evectionTripList.push(this.ruleForm.evectionTrip);
				this.$set(this.evectionTripList, e, {
					id: "",
					dictionaries_id: "",
					start_city: "",
					end_city: "",
					trip_type: "",
					trip_duration: "",
					start_date: "",
					end_date: "",
					index: e
				})
			},
			//减少行程
			delTtinerary(e) {
				this.ruleForm.evectionTripList.splice(e, 1);
				this.evectionTripList.splice(e, 1);
			},
			//添加同行人选择页面
			StaffFinds() {
				this.dialogVisible = true;
			},
			//添加同行人
			// saveChanges() {
			// 	this.staffList.forEach(item => {
			// 		if (item.id === this.staff_id) {
			// 			this.together_evections.push(item);
			// 		}
			// 	})
			// 	this.staff_id = "";
			// 	this.dialogVisible = false;
			// },
			//设置确定
			saveChanges(e) {
				// this.together_evections.push({
				// 	id:e.staff_id
				// })
				var together_evection='';
				e.staff_ids.forEach(item =>{
					together_evection=together_evection+item+",";
				});
				this.ruleForm.together_evection =together_evection;
				this.ruleForm.staff_names = e.staff_name;
				debugger
				this.dialogVisible = false;
				
			},
			//减少同行人
			// DelStaff(e) {
			// 	this.together_evections.splice(e, 1);
			// },
			//添加
			AddAuditor() {
				debugger
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Add() {
				var url = 'StaffEvection/insert';

				// this.ruleForm.together_evection = "";
				// this.together_evections.forEach(item => {
				// 	this.ruleForm.together_evection = this.ruleForm.together_evection +
				// 		',' + item.id;
				// })
				this.ruleForm.evectionTripList = this.evectionTripList;

				var record = {
					staff_id: this.ruleForm.staff_id,
					evection_reason: this.ruleForm.evection_reason,
					together_evection: this.ruleForm.together_evection,
					evectionTripList: this.ruleForm.evectionTripList,
					examineDetailsList: this.ruleForm.examineDetailsList,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//修改
			UpdateAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Update() {
				var url = 'StaffEvection/update';

				this.ruleForm.together_evection = "";
				this.together_evections.forEach(item => {
					this.ruleForm.together_evection = this.ruleForm.together_evection +
						',' + item.id;
				})
				this.ruleForm.evectionTripList = this.evectionTripList;

				var record = {
					id: this.ruleForm.id,
					staff_id: this.ruleForm.staff_id,
					evection_reason: this.ruleForm.evection_reason,
					together_evection: this.ruleForm.together_evection,
					evectionTripList: this.ruleForm.evectionTripList,
					examineDetailsList: this.ruleForm.examineDetailsList,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			StaffFind() {
				this.dialogVisibles = true;
			},
			
			//设置确定
			saveChange(e) {
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.staff_name = e.staff_name;
				this.dialogVisibles = false;
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.dialogAuditorVisible = false;
				this.$parent.Return();
			},
			Initialize() {

				this.evectionTripList = [];
				this.ruleForm.evectionTripList.forEach(item => {
					this.evectionTripList.push(item);
				});

				this.together_evections = [];
				this.staffList.forEach(staff => {
					this.ruleForm.together_evection.split(",").forEach(item => {
						if (item != null && item != '') {
							var id = parseInt(item);
							if (id === staff.id) {
								this.together_evections.push(staff);
							}
						}
					})
				})
			}
		},
		async created() {
			// 员工下拉
			var staffList = await this.$globals.AxiosPost("staff/selectFind", {});
			this.staffList = staffList.data;
			// 交通工具
			var dictionariesList = await this.$globals.AxiosPost("dictionaries/selectFind", {
				data_grouping: "traffic_vehicle"
			});
			this.dictionariesList = dictionariesList.data;

			this.ruleForm = this.$parent.ruleForm;
		},
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// Ccsq_add.vue?0b929f56